import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # InfraImage
 *
 * InfraImage을 설명하세요.
 */
export const InfraImage = types
  .model('InfraImage')
  // --------------------------------------------------------------------------
  .props({
    imageSid: types.optional(types.identifierNumber, 0),
    infraNm: types.optional(types.string, ''), // 구성도 명
    imageNm: types.optional(types.string, ''),
    imageOrigNm: types.optional(types.string, ''),
    imagePath: types.optional(types.string, ''), // 구성도 이미지
    imageSize: types.optional(types.string, ''),
    remark: types.maybeNull(types.optional(types.string, '')), // 비고

    useYn: types.optional(types.string, 'Y'),
    delYn: types.optional(types.string, 'N'),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model infraImage --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: IInfraImage }) => {
      const newProps = { ...self, ...props } as IInfraImage;
      (Object.keys(newProps) as TInfraImageKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TInfraImage = Instance<typeof InfraImage>;
type TInfraImageSnapshot = SnapshotOut<typeof InfraImage>;

export interface IInfraImage extends TInfraImage {}
export type TInfraImageKeys = keyof TInfraImageSnapshot & string;
export interface IInfraImageSnapshot extends TInfraImageSnapshot {}
export const createInfraImage = () => types.optional(InfraImage, {} as TInfraImage);
